<div class="error-box">
    <h1>Processing Error</h1>
    <h4>Error occurred while processing data</h4>
    <div *ngIf="analysisType === 'qPCR-Compilation'">
        <h4>{{display}}</h4>
    </div>
</div>

<mat-expansion-panel *ngFor="let error_message of display | keyvalue" class="panel-box">
    <mat-expansion-panel-header>
        <mat-panel-title><b>{{error_message.key}}</b></mat-panel-title>
    </mat-expansion-panel-header>
    <div *ngFor="let value of error_message.value" style="text-align: justify;"> {{value}}</div>
</mat-expansion-panel>